<template>
  <div class="clock-entry-wrapper">
    <!-- Mode 1: Dialog -->
    <v-dialog v-if="!embedded" v-model="dialog" class="dialog-wrapper" width="650px">

    <template v-slot:activator="{ on, attrs }">
      <!-- Opción 1: Modern Style (Home Tabs style) -->
      <v-card
        v-if="buttonStyle === 'Modern'"
        class="home-card modern-clock-btn"
        v-bind="attrs"
        v-on="on"
        @click="openDialog"
        :elevation="$getCardOptions('elevation')"
      >
        <v-icon size="48" :color="$getColor('vuetifyColor1')">mdi-clock</v-icon>
        <h3>Fichar</h3>
      </v-card>

      <!-- Opción 2: Classic Style (Original button) -->
      <v-btn
        v-else
        class="mt-4"
        :dark="$getPrimaryButton('dark')"
        depressed
        :rounded="$getPrimaryButton('rounded')"
        :outlined="false"
        :color="$getPrimaryButton('color')"
        v-bind="attrs"
        v-on="on"
        large
        @click="openDialog"
      >
        <v-icon left>mdi-clock</v-icon>Fichar
      </v-btn>
    </template>
    <v-container fluid>
      <v-card outlined class="p-3" :elevation="$getCardOptions('elevation')">
        <v-card-title class="p-0">
          <v-spacer></v-spacer>
          <v-btn class="ml-auto" :rounded="$getPrimaryButton('rounded')"
                :color="$getPrimaryButton('color2')" @click="closeDialog" :disabled="false"
                :loading="loading" icon large>
                <v-icon large>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-title class="pt-0">
          <section-header :first="ComputedTexts.first" :second="ComputedTexts.second" />
        </v-card-title>
        <v-card-text v-if="!loading">
          <v-form ref="form">
            <div v-if="holidayInfo.isHoliday" class="holiday-banner mb-4" :class="'holiday-type-' + holidayInfo.colorKey">
              <v-icon small left class="mr-1">mdi-calendar-alert</v-icon>
              <span>{{ holidayInfo.type }}</span>
              <span v-if="holidayInfo.description"> - {{ holidayInfo.description }}</span>
            </div>
            <div class="box-info">
              <v-icon style="margin: auto;" size="125" v-if="lastClockInTimeType === 'CLOCK_OUT'  || lastClockInTimeType === null"
                :color="$getPrimaryButton('color')">mdi-clock-plus</v-icon>
                <v-icon style="margin: auto;" size="125" v-if="lastClockInTimeType === 'CLOCK_IN'"
                color="success">mdi-progress-clock</v-icon>
            </div>
            <div class="box-info">
              <div class="input-clock--label" v-if="lastClockInTimeType === 'CLOCK_OUT' || lastClockInTimeType === null" > {{ ComputedDateTimeNow }} </div>
              <div class="input-clock--label" style="color: var(--color2)"  v-if="lastClockInTimeType === 'CLOCK_IN'"> {{ ComputedDifferenceTime }}
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-container>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn v-if="!loading" class="pr-2 white--text" :rounded="$getPrimaryButton('rounded')"
                :outlined="$getPrimaryButton('outlined')" :color="lastClockInTimeType === 'CLOCK_IN' ? $getPrimaryButton('color') : 'success' "
                @click="addClockEntry" :disabled="false" :loading="loading" width="48%" large block>
                <v-icon class="pr-3" left>{{ lastClockInTimeType === "CLOCK_IN" ? "mdi-stop" : "mdi-play"
                  }}</v-icon>
                {{ lastClockInTimeType === "CLOCK_IN" ? "Parar" : "Iniciar" }}
              </v-btn>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-dialog>

  <!-- Mode 2: Embedded -->
  <v-card v-else outlined class="p-3" :elevation="$getCardOptions('elevation')">
    <v-card-title class="pt-0">
      <section-header :first="ComputedTexts.first" :second="ComputedTexts.second" />
    </v-card-title>
    <v-card-text v-if="!loading">
      <v-form ref="form">
        <div v-if="holidayInfo.isHoliday" class="holiday-banner mb-4" :class="'holiday-type-' + holidayInfo.colorKey">
          <v-icon small left class="mr-1">mdi-calendar-alert</v-icon>
          <span>{{ holidayInfo.type }}</span>
          <span v-if="holidayInfo.description"> - {{ holidayInfo.description }}</span>
        </div>
        <div class="box-info">
          <v-icon style="margin: auto;" size="125" v-if="lastClockInTimeType === 'CLOCK_OUT'  || lastClockInTimeType === null"
            :color="$getPrimaryButton('color')">mdi-clock-plus</v-icon>
            <v-icon style="margin: auto;" size="125" v-if="lastClockInTimeType === 'CLOCK_IN'"
            color="success">mdi-progress-clock</v-icon>
        </div>
        <div class="box-info">
          <div class="input-clock--label" v-if="lastClockInTimeType === 'CLOCK_OUT' || lastClockInTimeType === null" > {{ ComputedDateTimeNow }} </div>
          <div class="input-clock--label" style="color: var(--color2)"  v-if="lastClockInTimeType === 'CLOCK_IN'"> {{ ComputedDifferenceTime }}
          </div>
        </div>
      </v-form>
    </v-card-text>
    <v-card-actions class="mt-5">
      <v-spacer></v-spacer>
      <v-container>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn v-if="!loading" class="pr-2 white--text" :rounded="$getPrimaryButton('rounded')"
            :outlined="$getPrimaryButton('outlined')" :color="lastClockInTimeType === 'CLOCK_IN' ? $getPrimaryButton('color') : 'success' "
            @click="addClockEntry" :disabled="false" :loading="loading" width="48%" large block>
            <v-icon class="pr-3" left>{{ lastClockInTimeType === "CLOCK_IN" ? "mdi-stop" : "mdi-play"
              }}</v-icon>
            {{ lastClockInTimeType === "CLOCK_IN" ? "Parar" : "Iniciar" }}
          </v-btn>
        </v-row>
      </v-container>
    </v-card-actions>
  </v-card>
</div>
</template>

<script>
import clockEntryService from '@/services/clockentry.service';
import WorkCenterCalendarService from '@/services/workcenter-calendar.service';
import ConfigureTimeService from '@/services/configure-time.service';

import SectionHeader from '@/components/Headers/SectionHeader.vue';
import moment from 'moment-timezone';

export default {
  name: 'clock-entry-register',
  data: () => ({

    dialog: false,
    loading: false,
    currentDateTime: null,
    lastClockInTimeType: null,
    lastClockInTimeDate: null,
    DateTimeNow: new Date(),
    calendarEntries: [],

    typeColorMap: {
      'FIESTA NACIONAL': 'red',
      'FIESTA AUTONOMICA': 'yellow',
      'FIESTA LOCAL': 'green',
      'FIESTA CONVENIO': 'orange',
      'AJUSTE HOR. CONVENIO': 'lightblue',
      'NO LABORABLE NO RECUP.': 'purple',
    },

    location: {
      latitude: null,
      longitude: null,
      errorLocation: null,
    },

  }),
  props: {
    workerId: {
      required: true,
    },
    worker: {
      required: false,
    },
    isAdmin: {
      type: Boolean,
      required: true,
      default: false,
    },
    currentValue: {
      required: false,
    },
    buttonStyle: {
      type: String,
      default: 'Classic', // 'Classic' or 'Modern'
    },
    embedded: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SectionHeader,
  },
  computed: {
    ComputedDateTimeNow() {
      return this.DateTimeNow.toLocaleString();
    },

    ComputedDifferenceTime() {
      const diferencia = this.DateTimeNow - this.lastClockInTimeDate;

      const horas = Math.floor(diferencia / (1000 * 60 * 60));
      const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
      const segundos = Math.floor((diferencia % (1000 * 60)) / 1000);
      return `${horas} h, ${minutos} min y ${segundos} seg`;
    },
    ComputedTexts() {
      if (this.loading) {
        return { first: '', second: 'Cargando...' };
      }
      if (this.lastClockInTimeType && this.lastClockInTimeType === 'CLOCK_IN') {
        return { first: 'Pincha en parar', second: 'para fichar la salida...' };
      }
      return { first: 'Pincha en iniciar', second: 'para fichar la entrada...' };
    },
    holidayInfo() {
      const dateString = moment(this.DateTimeNow).format('YYYY-MM-DD');
      const calendarEntry = this.calendarEntries && this.calendarEntries.find((entry) => moment.utc(entry.date).format('YYYY-MM-DD') === dateString);
      if (calendarEntry) {
        if (!calendarEntry.available) {
          const type = calendarEntry.type || 'FESTIVO';
          const description = calendarEntry.description || '';
          const colorKey = this.typeColorMap[type] || 'grey';
          return {
            isHoliday: true,
            type,
            description,
            colorKey,
          };
        }
        return { isHoliday: false };
      }
      const isWeekend = ConfigureTimeService.isWeekend(dateString);
      if (isWeekend) {
        return {
          isHoliday: true,
          type: 'FIN DE SEMANA',
          description: '',
          colorKey: 'grey',
        };
      }
      return { isHoliday: false };
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.updateCurrentDateTime();
        this.fetchLocation();
        this.fetchCalendarEntries();
      }
    },
    worker: {
      handler() {
        this.fetchCalendarEntries();
      },
      deep: true,
    },
  },
  mounted() {
    this.getLastClockEntry();
    this.fetchLocation();
    this.fetchCalendarEntries();
    // Actualizar fecha y hora cada segundo
    setInterval(() => {
      this.DateTimeNow = new Date();
    }, 1000);
  },
  methods: {
    fetchCalendarEntries() {
      const workCenterId = (this.worker && this.worker.workCenter && this.worker.workCenter.id) || this.$store.state.projectId;
      if (!workCenterId) return;
      const params = {
        page: 0,
        size: 1000,
        sort: 'date',
        direction: 'asc',
      };
      WorkCenterCalendarService.getCalendarEntriesByWorkCenter(workCenterId, params)
        .then((response) => {
          this.calendarEntries = (response.data && response.data.content) ? response.data.content : [];
        })
        .catch((error) => {
          console.error('Error fetching calendar entries in CreateClockEntry:', error);
        });
    },
    async fetchLocation() {
      try {
        const location = await clockEntryService.getLocation(navigator.geolocation);
        this.location.latitude = location.latitude;
        this.location.longitude = location.longitude;
        this.location.errorLocation = null;
      } catch (error) {
        this.location.latitude = null;
        this.location.longitude = null;
        this.location.errorLocation = error;
      }
    },
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    updateCurrentDateTime() {
      const now = new Date();
      // Formatear la fecha y hora según tus necesidades
      const formattedDateTime = this.formatDateTime(now);
      this.currentDateTime = formattedDateTime;
    },
    formatDateTime(dateTime) {
      const options = {
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric',
      };
      return new Intl.DateTimeFormat('es-ES', options).format(dateTime);
    },
    getLastClockEntry() {
      this.loading = true;
      clockEntryService.getLastClockEntry(this.worker.id).then((response) => {
        if (response) {
          this.lastClockInTimeType = response.type;
          // this.lastClockInTimeDate = new Date(response.clockInTime);
          // Convertir el tiempo Unix a la fecha y hora de Madrid
          const lastClockInTimeUnixFormated = moment.unix(response.unixClockInTime).tz('Europe/Madrid');
          // Formatear la fecha y hora en el formato deseado
          this.lastClockInTimeDate = new Date(lastClockInTimeUnixFormated);
        }
        this.loading = false;
      });
    },
    addClockEntry() {
      this.loading = true;
      clockEntryService.addClockEntry(this.worker.id, this.location)
        .then(() => {
          this.getLastClockEntry();
          this.refreshClockEntries();
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
        });
    },
    refreshClockEntries() {
      this.$emit('refreshClockEntries');
    },
  },
};
</script>
<style scoped>
.input-clock--label{
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: calc(var(--base) * 3);
  margin-left: auto;
  margin-right: auto;
  color: var(--color1);
  font-weight: 300;
}
.box-info{
  display: flex;
  margin: auto;
}
.clock-entry-wrapper {
  display: contents;
}

.holiday-banner {
  width: 100%;
  padding: 10px 16px;
  border-radius: 6px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.3px;
}

.holiday-type-red {
  background-color: #ffcdd2;
  color: #b71c1c;
  border: 1px solid #ef9a9a;
}
.holiday-type-red .v-icon {
  color: #b71c1c !important;
}

.holiday-type-yellow {
  background-color: #fff9c4;
  color: #f57f17;
  border: 1px solid #fff176;
}
.holiday-type-yellow .v-icon {
  color: #f57f17 !important;
}

.holiday-type-green {
  background-color: #c8e6c9;
  color: #1b5e20;
  border: 1px solid #81c784;
}
.holiday-type-green .v-icon {
  color: #1b5e20 !important;
}

.holiday-type-orange {
  background-color: #ffe0b2;
  color: #e65100;
  border: 1px solid #ffb74d;
}
.holiday-type-orange .v-icon {
  color: #e65100 !important;
}

.holiday-type-lightblue {
  background-color: #b3e5fc;
  color: #01579b;
  border: 1px solid #4fc3f7;
}
.holiday-type-lightblue .v-icon {
  color: #01579b !important;
}

.holiday-type-purple {
  background-color: #e1bee7;
  color: #4a148c;
  border: 1px solid #ba68c8;
}
.holiday-type-purple .v-icon {
  color: #4a148c !important;
}

.holiday-type-grey {
  background-color: #eeeeee;
  color: #424242;
  border: 1px solid #e0e0e0;
}
.holiday-type-grey .v-icon {
  color: #424242 !important;
}
</style>
